import React, { Component } from "react";
import { connect } from "react-redux";
import styles from "./CareersPage.scss";
import axios from "axios";
import _ from "lodash";
import CareerSearchKeyword from "./CareerSearchKeyword";
import CareerSearchLinkedIn from "./CareerSearchLinkedIn";
import CareerSearchResume from "./CareerSearchResume";
import CareerSearchMatching from "./CareerSearchMatching";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faLock } from "@fortawesome/free-solid-svg-icons";
import { authLinkedin } from "../../../actions/Careers/linkedinAction";
import {
	removeVisitor,
	setUserInfo,
	updateVisitor
} from "../../../actions/DataCol/userdataAction";

import classnames from "classnames";

class CareersPage extends Component {
	constructor(props) {
		super(props);
		this.state = {
			// showSpousal: false,
			jobs: [],
			headline: undefined,
			summary: undefined,
			searchString: undefined,
			linkedInIsAuthorized: false,
			linkedin_recommendations: undefined,
			linkedin_user_data: undefined,
			LinkedInURL: "",
			resume_recommendations: undefined,
			unsubscribe_email: "",
			resume_uploaded: true
		};
	}

	resetToOriginalState = () => {
		this.setState({
			headline: undefined,
			summary: undefined,
			searchString: undefined,
			linkedInIsAuthorized: false,
			linkedin_recommendations: undefined,
			resume_recommendations: undefined
		});
	};

	// componentDidUpdate(prevProps, prevState) {
	//   if (this.state.linkedin_loggedin !== prevState.linkedin_loggedin){
	//     console.log("linkedin_loggedin CHANGED: ", this.state.linkedin_loggedin);
	//   }
	// }

	componentDidMount() {
		// console.log("ENV: ", process.env.NODE_ENV);
		// Get the first 100 jobs

		this.getFirst100Jobs();
		let type = this.props.location.search.split("=")[0];

		if (this.props.location.search === "") {
		} else if (
			sessionStorage.getItem("linkedin") === this.props.location.search
		) {
			console.log("LINE 41");
		} else if (type === "?query") {
			console.log("TYPE: ", type);
			this.setState(
				{
					search_method: "keyword",
					searchString: this.props.location.search
						.split("=")[1]
						.split("+")
						.join(" ")
					// ADD SEARCH STRING TO PASS HERE
				},
				() => {
					console.log("searchString: ", this.state.searchString);
				}
			);
		} else if (type === "?code") {
			var code = this.props.location.search.slice(6).slice(0, -21);

			sessionStorage.setItem("linkedin", this.props.location.search);

			this.setState({
				search_method: "linkedin"
			});
			authLinkedin(code).then(res => {
				this.props.history.push("careers");
				if (res.data.success === true) {
					this.setState({
						linkedInIsAuthorized: true,
						loading: true,
						linkedin_recommendations: res.data.data
					});
				}
				sessionStorage.setItem("linkedin", "");
			});
		}
	}

	setSearchUsed = search => {
		var user = this.props.user;
		if (user) {
			if (search === "keyword") {
				user.usedRegularSearch = true;
			} else if (search === "matching") {
				user.usedFindSimilar = true;
			}
			updateVisitor(user);
			this.props.setUserInfo(user);
		}
	};

	getLinkedInRecommendations = () => {

	}

	setInfo = resumeInfo => {
		var user = this.props.user;
		if (user && !_.isEmpty(user)) {
			user["usedResumeSearch"] = true;
			user["resume"] = resumeInfo;
			updateVisitor(user);
			this.props.setUserInfo(user);
		}
	};

	handleUploadFile = event => {
		const data = new FormData();
		if (event.target.files[0].type === "application/pdf") {
			data.append("file", event.target.files[0]);
			data.append("name", event.target.files[0].name);
			data.append("description", "user's resume");
			console.log("I am loading your resume...");
			this.setState({
				search_method: "resume"
			});

			// '/files' is your node.js route that triggers our middleware
			axios.post("/api/resume", data).then(response => {
				// HERE IS WHAT AKING TOLD YOU TO DO

				this.setInfo(response.data.resumeInfo);
				this.setState({
					resume_recommendations: response.data.data
				});
			});
		} else {
			this.setState({
				resume_uploaded: false
			});
		}
	};

	setProfile = profile => {
		this.setState({
			search_method: undefined,
			headline: profile.headline,
			summary: profile.summary,
			name: profile.firstName + " " + profile.lastName
			// linkedin_loggedin: true
		});
	};

	setLinkedInAuth = value => {
		this.setState({
			linkedInIsAuthorized: value
		});
	};

	resetProfile = () => {
		this.setState({
			headline: undefined,
			summary: undefined,
			name: undefined
			// linkedin_loggedin: false
		});
	};

	getFirst100Jobs = () => {
		axios
			.get("/api/jobs/100jobs", {
				headers: { Authorization: "Bearer K1Ng57ONHUB4PIK3Y" }
			})
			.then(res => {
				this.setState(
					{
						jobs: res.data
					},
					() => this.getAllJobs()
				);
			})
			.catch(e => console.log(e));
	};

	getAllJobs = () => {
		axios
			.get("/api/jobs", {
				headers: { Authorization: "Bearer K1Ng57ONHUB4PIK3Y" }
			})
			.then(res => {
				this.setState({
					jobs: [...this.state.jobs, ...res.data.slice(100)]
				});
			})
			.catch(e => console.log(e));
	};

	handleEmailChange = event => {
		this.setState({
			unsubscribe_email: event.target.value
		});
	};
	handleLinkedInChange = event => {
		this.setState({
			LinkedInURL: event.target.value
		});
	};

	unsubscribe = () => {
		// this.props.history.push(
		//   `/unsubscribe?email=${this.state.unsubscribe_email}`
		// );
		removeVisitor(this.state.unsubscribe_email).then(() => {
			this.setState({
				unsubscribe_email: ""
			});
		});
	};

	handleLinkedinClick = () => {
					this.setState({
							search_method: "linkedin2"
						}, () => this.LinkedInUpdate());
	}

	LinkedInUpdate = () => {
		console.log(this.state.LinkedInURL);
		axios
			.post("/api/linkedin/new", {"url": "https://www.linkedin.com/in/" + this.state.LinkedInURL}, {
				headers: { Authorization: "Bearer K1Ng57ONHUB4PIK3Y" }
			})
			.then(res => {
				this.setState({
					linkedin_user_data: res.data
				});

				let user = this.props.user;
				user["usedLinkedinSearch"] = true;
				user["linkedin"] = res.data.jobs;
				console.log(user);
				updateVisitor(user);
				this.props.setUserInfo(user);
				axios.post("/api/linkedin/data", {"jobs": res.data.jobs}, {
					headers: { Authorization: "Bearer K1Ng57ONHUB4PIK3Y" }
				})
				.then(res =>{
					this.setState({
						linkedin_recommendations: res.data.data
					});
					// console.log(res.data)

				})
			})
	}

	render() {
		return (
			<div>
			<div className={classnames(styles.container)}>
					{/*<h1 className={styles.title}>
						Discover Your Career in Kingston
					</h1>*/}
					{/*this.state.search_method === undefined && (
						<div className="row">
							<div className="col-sm-6">
								<div
									className={classnames("card", styles.card)}
								>
									<div
										className={classnames(
											"card-body",
											styles.cardBig
										)}
									>
										<img
											src={require("./images/LinkedIn_Logo.png")}
											alt="linkedin-logo"
										/>
										<h5 className="card-title">
											Search for Jobs Using Your LinkedIn
											Profile
										</h5>
										<div className="form-group">
											<input
												type="email"
												className="form-control"
												placeholder="LinkedIn Username"
												value={this.state.LinkedInURL}
												onChange={this.handleLinkedInChange}
											/>
										</div>
										<label
											className="btn btn-primary"
											onClick={this.handleLinkedinClick}
										>
											Search
										</label>
										<p className="text-muted">
											<small>
												By submitting your LinkedIn profile, 
												you agree to let the City of Kingston store data. 
												Data is secure, private, not shared, 
												and can be deleted at any time *
											</small>
										</p>
									</div>
								</div>
							</div>
							<div className="col-sm-6">
								<div
									className={classnames("card", styles.card)}
								>
									<div
										className={classnames(
											"card-body",
											styles.cardBig
										)}
									>
										<img
											src={require("./images/download.png")}
											alt="download"
										/>
										<h5 className="card-title">
											Upload Your Resume
										</h5>
										<p className="card-text">
											Discover your future career using
											our intelligent algorithm to search
											for jobs using your resume and
											previous experience.
										</p>
										<label
											htmlFor="file"
											className="btn btn-primary"
										>
											<FontAwesomeIcon
												icon={faLock}
												className={styles.arrowLeft}
											/>
											Upload Resume
										</label>
										<input
											className={styles.fileInput}
											type="file"
											id="file"
											name="file"
											accept="application/pdf"
											onChange={this.handleUploadFile}
										/>

										{!this.state.resume_uploaded ? (
											<span className="alert alert-danger">
												<strong>
													This tool only accepts PDF
												</strong>
											</span>
										) : (
											<p className="text-muted">
												<small>
													Data is secure, private, not
													shared, and can be deleted at
													any time.*
												</small>
											</p>
										)}
									</div>
								</div>
							</div>
							*/}
				{this.state.search_method === undefined && (
						<div className="row">
							<div className="col-sm-6">
								<div
									className={classnames("card", styles.card)}
								>
									<div
										className={classnames(
											"card-body",
											styles.cardSmall
										)}
									>
										<h5 className="card-title">
											Use Our Matching Technique
										</h5>
										<p className="card-text">
											Tell us what interests you and we'll
											try to find the perfect job for you
											using our matching technique.
										</p>
										<label
											className="btn btn-primary"
											onClick={() =>
												this.setState(
													{
														search_method:
															"matching"
													},
													() =>
														this.setSearchUsed(
															"matching"
														)
												)
											}
										>
											Find Matches
										</label>
									</div>
								</div>
							</div>
							<div className="col-sm-6">
								<div
									className={classnames("card", styles.card)}
								>
									<div
										className={classnames(
											"card-body",
											styles.cardSmall
										)}
									>
										<h5 className="card-title">
											Search By Keyword
										</h5>
										<p className="card-text">
											Find the perfect job using our key word search.
										</p>
										<label
											className="btn btn-primary"
											onClick={() =>
												this.setState(
													{
														search_method: "keyword"
													},
													() =>
														this.setSearchUsed(
															"keyword"
														)
												)
											}
										>
											Search
										</label>
									</div>
								</div>
							</div>
						</div>
					)}

					{/*!this.state.showSpousal && (
          <div className={styles.subtitle} onClick={() => this.toggleSpousal()}>
            Have a spouse? Search for their career too by clicking here!
          </div>
        )}

        {this.state.showSpousal && (
          <div className={styles.subtitle} onClick={() => this.toggleSpousal()}>
            Click here to hide spousal jobs!
          </div>
        )*/}

					{(//this.state.search_method === "linkedin2" ||
						this.state.search_method === "keyword" ||
						this.state.search_method === "matching" //||
						//this.state.search_method === "resume"
						) 
						&& (
						<div
							className={classnames(styles.newMethod)}
							onClick={() =>
								this.setState({
									search_method: undefined,
									linkedin_recommendations: undefined
								})
							}
						>
							<FontAwesomeIcon
								icon={faArrowLeft}
								onClick={this.w3_close}
								className={styles.arrowLeft}
							/>
							<p>Search using a different method. </p>
						</div>
					)}

					{this.state.search_method === "matching" && (
						<CareerSearchMatching
							resetToOriginalState={this.resetToOriginalState}
							jobs={this.state.jobs}
						/>
					)}

					{this.state.search_method === "keyword" && (
						<CareerSearchKeyword
							resetToOriginalState={this.resetToOriginalState}
							jobs={this.state.jobs}
							searchString={this.state.searchString}
						/>
					)}

					{/*this.state.search_method === "linkedin2" && (
						<CareerSearchLinkedIn
							resetToOriginalState={this.resetToOriginalState}
							jobs={this.state.jobs}
							linkedin_recommendations={
								this.state.linkedin_recommendations
							}
						/>
					)*/}

					{/*this.state.search_method === "resume" && (
						<CareerSearchResume
							resetToOriginalState={this.resetToOriginalState}
							jobs={this.state.jobs}
							resume_recommendations={
								this.state.resume_recommendations
							}
						/>
					)*/}

					{/*this.state.showSpousal && (
            <CareerSearch
              splitScreen={this.state.showSpousal}
              jobs={this.state.jobs}
              linkedin_loggedin={false}
            />
          )*/}
					{/*
        </div> */}
				</div>
				{this.state.search_method === undefined && (
					<div className={classnames(styles.careerfooter)}>
						<div className="row">
							<div className="col-sm-8">
								<small>
									*Your data is stored on our secure servers 
									for a period of 12 months to keep you up to date 
									with Kingston news and opportunities. 
									Your data never leaves our servers and is never shared 
									with any parties outside the city of Kingston. 
									You can delete all your data from our servers at anytime.
								</small>
							</div>
							<div className="col-sm-4 ">
								<small>Request Removal of User's Data</small>
								<div className="input-group">
									<input
										type="email"
										className="form-control"
										placeholder="Email Address"
										value={this.state.unsubscribe_email}
										onChange={this.handleEmailChange}
									/>
									<button
										className="btn btn-outline-secondary"
										type="button"
										onClick={this.unsubscribe}
									>
										Submit
									</button>
								</div>
							</div>
						</div>
					</div>
				)}
			</div>
		);
	}
}

function mapStateToProps(state) {
	return {
		user: state.user.user
	};
}

const actions = {
	setUserInfo
};

export default connect(
	mapStateToProps,
	actions
)(CareersPage);



// WEBPACK FOOTER //
// ./src/components/pages/Careers/CareersPage.js